import React from "react";
import logo from "./logo.svg";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import PageHome from "./pages/home";
import PageRedeem from "./pages/redeem";
import PageCheckout from "./pages/checkout";
import PageLogin from "./pages/login";
import PageEvent from "./pages/event";
import PageReport from "./pages/report";
import PageQRList from "./pages/qrlist";
import PageEditData from "./pages/edit";
import PageInfo from "./pages/info";
import PageSymposium from "./pages/info/symposium";
import PageWorkshop from "./pages/info/workshop";
import PagePoster from "./pages/info/poster";
import PageHotel from "./pages/info/hotel";
import PageDocumentation from "./pages/info/documentation";
import PageContact from "./pages/info/contact";
import PageHomeTest from "./pages/home/index_test";
import PagePayment from "./pages/payment";

function App() {
  return (
    <Routes>
      <Route path="/" element={<PageHome />} />
      <Route path="/payment" element={<PagePayment />} />
      {/* <Route path="/test" element={<PageHomeTest />} /> */}
      <Route path="/event-info" element={<PageInfo />} />
      <Route path="/symposium" element={<PageSymposium />} />
      <Route path="/workshop" element={<PageWorkshop />} />
      <Route path="/poster-competition" element={<PagePoster />} />
      <Route path="/hotel" element={<PageHotel />} />
      <Route path="/documentation" element={<PageDocumentation />} />
      <Route path="/contact-us" element={<PageContact />} />
    </Routes>
  );
}

export default App;
